import { useEffect } from 'react';
import { decryptString } from '../utilities/aesGcmEncryption';
import useGetPlatformInfo from './useGetPlatformInfo';

export type CustomEvent = {
    data: string;
};

function useCustomEvent(
    eventName: string,
    callback: (data: string | null) => void,
    encrypt = false,
) {
    const { isShellApp } = useGetPlatformInfo();

    useEffect(() => {
        const handleEvent = (event: Event) => {
            const { detail } = event as globalThis.CustomEvent<string>;

            if (encrypt) {
                decryptString<string>(detail)
                    .then((decryptedData) => {
                        callback(decryptedData);
                    })
                    .catch(() => {
                        callback(null);
                    });
                return;
            }

            callback(detail ?? null);
        };

        if (isShellApp) {
            window.addEventListener(eventName, handleEvent);
        }

        return () => {
            if (isShellApp) {
                window.removeEventListener(eventName, handleEvent);
            }
        };
    }, [eventName, callback, encrypt, isShellApp]);
}

export default useCustomEvent;
